import { StyleSheet } from 'aphrodite';
import iconLink from 'assets/images/icon-link.svg';
import { defaultStyles, imagesUrl } from 'library';

const styles = StyleSheet.create({
    product: {
        display: 'flex',
        flexDirection: 'column',
        border: '1px solid ' + defaultStyles.greyLight,
        backgroundColor: defaultStyles.white,
        '@media screen and (min-width: 768px)': {
            flexDirection: 'row',
        },
        '@media print': {
            flexDirection: 'row',
            paddingTop: '0px',
        },
    },
    textWrapper: {
        display: 'flex',
        flexDirection: 'column',
        padding: '32px',
        '@media screen and (min-width: 768px)': {
            margin: '0',
            flexDirection: 'row',
            flexBasis: 'calc(100% - 200px)',
            justifyContent: 'space-between',
        },
    },
    productTitleWrapper: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
    },
    figure: {
        margin: '0',
        '@media screen and (min-width: 768px)': {
            flexBasis: '200px',
            display: 'flex',
            justifyContent: 'space-around',
            flexDirection: 'column',
        },
    },
    image: {
        width: '100%',
        maxWidth: '100%',
        '@media screen and (min-width: 768px)': {
            width: '200px',
        },
    },
    title: {
        display: 'inline-block',
        margin: '0',
        color: defaultStyles.greyTitle,
        fontSize: '24px',
        lineHeight: '30px',
        fontWeight: 'bold',
        minWidth: '80%',
    },
    descriptionWrapper: {
        flexBasis: '70%',
    },
    description: {
        paddingLeft: '10px',
        color: defaultStyles.greyText,
    },
    link: {
        display: 'inline-block',
        color: defaultStyles.blue,
        textDecoration: 'none',
        textTransform: 'uppercase',
        fontSize: '14px',
        fontWeight: '700',
        marginTop: '1rem',
        position: 'relative',
        ':after': {
            content: '\'\'',
            display: 'block',
            marginRight: '5px',
            // backgroundImage: 'url(' + imagesUrl.int + iconLink +')',
            width: '20px',
            height: '20px',
            position: 'absolute',
            top: '0',
            right: '0',
        },
        ':hover': {
            textDecoration: 'underline'
        },
        '@media print': {
            display: 'none'
        }
    },
    iconLinkInt: {
        ':after': {
            backgroundImage: 'url(' + imagesUrl.int + iconLink + ')',
        }
    },
    iconLinkQual: {
        ':after': {
            backgroundImage: 'url(' + imagesUrl.qual + iconLink + ')',
        }
    },
    iconLinkProd: {
        ':after': {
            backgroundImage: 'url(' + imagesUrl.prod + iconLink + ')',
        }
    },
    iconLinklocal: {
        ':after': {
            backgroundImage: 'url(' + imagesUrl.local + iconLink + ')',
        }
    },
});

export default styles;